// Chama POST /ai/agent e devolve { reply, actions }. As actions são aplicadas
// no store por applyAgentActions(). Mesmo padrão de fetch do AIChatDrawer (cookie auth).

import type { AgentAction } from './agentActions.js';

export interface AgentResponse {
  reply: string;
  actions: AgentAction[];
}

export interface AgentTurnMsg {
  role: 'user' | 'assistant';
  content: string;
}

export async function runAgent(
  workspaceId: string,
  query: string,
  context?: string,
  history?: AgentTurnMsg[],
): Promise<AgentResponse> {
  const res = await fetch('/api/ai/agent', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      workspaceId,
      query,
      context: context || undefined,
      history: history && history.length ? history : undefined,
    }),
  });
  if (!res.ok) {
    let detail = String(res.status);
    try {
      const j = await res.json();
      detail = j?.error ?? detail;
    } catch {
      /* corpo não-JSON */
    }
    throw new Error(detail);
  }
  const data = (await res.json()) as AgentResponse;
  return { reply: data.reply ?? '', actions: Array.isArray(data.actions) ? data.actions : [] };
}
